import request from '@/utils/request'

// 查询企业资质列表
export function listBusinessqualification(query) {
  return request({
    url: '/screen/creditlibrary/businessqualification/list',
    method: 'get',
    params: query
  })
}

// 查询企业资质详细
export function getBusinessqualification(pid) {
  return request({
    url: '/screen/creditlibrary/businessqualification/detail/' + pid,
    method: 'get'
  })
}

// 新增企业资质
export function addBusinessqualification(data) {
  return request({
    url: '/screen/creditlibrary/businessqualification/add',
    method: 'post',
    data: data
  })
}

// 修改企业资质
export function updateBusinessqualification(data) {
  return request({
    url: '/screen/creditlibrary/businessqualification/edit',
    method: 'post',
    data: data
  })
}

// 删除企业资质
export function delBusinessqualification(pid) {
  return request({
    url: '/screen/creditlibrary/businessqualification/delete/' + pid,
    method: 'get'
  })
}
